/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import LocationDropdown from '../LocationDropdown/LocationDropdown.jsx';

const LocationContent = ({ children, locations, currentPin, currentMap, title, onPinSelect, labels = {} }) => {
  return (
    <div className="location__content">
      <div className="location__sidebar">
        <div className="location__dropdown">
          <LocationDropdown locations={locations} currentPin={currentPin} currentMap={currentMap} onPinSelect={onPinSelect} labels={labels} />
        </div>
      </div>

      <div className="location__map-container">{children}</div>
    </div>
  );
};

// PropTypes definition
LocationContent.propTypes = {
  children: PropTypes.node.isRequired,
  locations: PropTypes.shape({}),
  currentPin: PropTypes.string,
  currentMap: PropTypes.string.isRequired,
  title: PropTypes.string,
  onPinSelect: PropTypes.func,
  labels: PropTypes.shape({})
};

// Default props
LocationContent.defaultProps = {
  locations: {},
  currentPin: null,
  title: null,
  onPinSelect: null,
  labels: {}
};

export default LocationContent;
